import { HYDRATE_STORE } from './navigation.actions'

const INITIAL_STATE = {
  bla: 'moshe',
}

export function navigationReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case HYDRATE_STORE:
      return { ...state, data: action.payload }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/navigation/navigation.reducers.js